import React from 'react';
import { ShieldCheck } from 'lucide-react';

export default function ReauthOverlay() {
  return (
    <div
      data-testid="reauth-overlay"
      className="fixed inset-0 bg-slate-50 flex flex-col items-center justify-center z-[100]"
    >
      <div className="flex flex-col items-center gap-5 max-w-xs text-center">
        {/* Pulsing icon */}
        <div className="relative">
          <div className="absolute inset-0 rounded-3xl bg-sky-400/20 animate-ping" />
          <div className="relative w-16 h-16 bg-sky-500 rounded-2xl flex items-center justify-center shadow-lg">
            <ShieldCheck className="w-9 h-9 text-white" />
          </div>
        </div>

        <div>
          <h2 className="text-slate-900 font-bold text-lg font-outfit">Syncing your permissions</h2>
          <p className="text-slate-500 text-sm mt-1 leading-relaxed">
            Google is issuing your updated family role.
            <br />You'll be back in a moment.
          </p>
        </div>

        <div className="flex gap-1.5">
          {[0, 1, 2].map(i => (
            <div
              key={i}
              className="w-2 h-2 bg-sky-400 rounded-full animate-bounce"
              style={{ animationDelay: `${i * 0.15}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
